import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import { useJumpLink } from '../../../../hooks';
import PricingCard from '../PricingCard';

import { Wrapper, StyledContainer, Cards } from './styles';

const PricingSection = ({ data }) => {
  if (!data) return null;
  const { titleHtml, subTitleHtml, items } = data;

  useJumpLink();

  return (
    <Wrapper id="pricing-details">
      <StyledContainer className="auto-margin">
        {ReactHtmlParser(titleHtml)}
        {ReactHtmlParser(subTitleHtml)}
        <Cards spacing="10px" columns={items.length}>
          {items.map((item, index) => {
            return (
              <PricingCard
                data={item}
                key={`pricing-card-${index.toString()}`}
              />
            );
          })}
        </Cards>
      </StyledContainer>
    </Wrapper>
  );
};

PricingSection.propTypes = {
  data: PropTypes.shape().isRequired,
};

PricingSection.defaultProps = {};

export default PricingSection;
